export default {"src":"/_next/static/media/started-icon.3d77cde4.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};